module.exports = __webpack_public_path__ + "media/3x/5-bb0f3030.png";